import { render, staticRenderFns } from "./Compliment.vue?vue&type=template&id=1f9ffc42"
import script from "./Compliment.vue?vue&type=script&lang=js"
export * from "./Compliment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports